import request from "@/api/request";

const mainServer = {

  sendVCode: (params) =>
    request.post(
      "/adminapi/message/sendMessage",
      params
    ),
  mobileLogin: ({ username, password }) =>
    // request.post(
    //   `/adminapi/admin/login?clientId=tl-oms&grantType=sms&password=${password}&username=${username}`,
    //   {}
    // ),
    request.post(
      `/adminapi/oauth/token?grant_type=sms&scope=all&username=${username}&password=${password}&client_id=tl-oms&client_secret=123`,
      {}
    ),

  accountLogin: ({ username, password }) =>
    request.post(
      `/adminapi/oauth/token?grant_type=password&scope=all&username=${username}&password=${password}&client_id=tl-oms&client_secret=123`,
      {}
    ),

  register: (params) =>
    request.post(
      "/adminapi/regist/apply",
      params
    ),
  logout: (params) =>
    request({
      url: "/adminapi/oauth/logout",
      method: "get",
      params: params,
    }),

  queryRoleList: (params) =>
    request({
      url: " /adminapi/role/queryRole/2",
      method: "get",
      params: params,
    }),

  queryBankList: (params) =>
    request({
      url: "/adminapi/dic/queryBankList",
      method: "get",
      params: params,
    }),
  queryProducts: (params) =>
    request({
      url: "/cbsapi/product/queryByParam",
      method: "get",
      params: params,
    }),
  queryTimeZones: () =>
    request({
      url: "/omsapi/order/getTimeZone",
      method: "get",
    }),
  queryCompanyInfo: (params) =>
    request({
      url: "/adminapi/customer/customerInfo",
      method: "get",
      params: params,
    }),
  queryCustomerInfo: (params) =>
    request({
      url: "/adminapi/customer/queryCustomerByid",
      method: "get",
      params: params,
    }),
  queryUserInfo: (params) =>
    request({
      url: "/adminapi/baseUser/queryUserById",
      method: "get",
      params: params,
    }),

  changePassword: (params) =>
    request.post(
      "/adminapi/baseUser/changePwd",
      params
    ),

  queryCountry: (params) =>
    request({
      url: "/adminapi/country/getALlCountry",
      method: "get",
      params: params,
    }),
};

export default mainServer;



// WEBPACK FOOTER //
// ./src/api/index.js